// extracted by mini-css-extract-plugin
module.exports = {"PageActions":"PageActions_PageActions_2uym5","Action":"PageActions_Action_3ubgy","PrimaryAction":"PageActions_PrimaryAction_1QEzE"};